module.exports = __webpack_public_path__ + "static/media/oct 2021.34c6956b.svg";